import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
} from "@mui/material";

const LegendStatusDefDialog = ({ open, onClose }) => {
  const rows = [
    {
      status: "Active",
      bg: "#238ccb", // blue
      definition:
        "BG is valid and outstanding",
    },
    {
      status: "Released",
      bg: "#9CCC65", // green
      definition:
        "BG returned / cancelled by beneficiary",
    },
    {
      status: "Encashed",
      bg: "#F44336", // red
      definition:
        "BG invoked and payment made by bank",
    },
     {
      status: "Expired",
      bg: "#FFC107", // amber
      definition:
        "BG validity lapsed — action required",
    },
     {
      status: "Renewed",
      bg: "#BF83FF", // purple
      definition:
        "BG renewed / extended before expiry",
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontFamily: "Outfit", fontWeight: 600 }}>
        Legend & Status Definitions
      </DialogTitle>

      <DialogContent dividers>
        <Typography
          sx={{
            mb: 2,
            fontSize: "14px",
            fontFamily: "Outfit",
            color: "#4B5563",
          }}
        >
          This table explains <strong>Status</strong> definitions.
        </Typography>

        <Box sx={{ overflowX: "auto" }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "250px 600px",
              border: "1px solid #000000",
              borderRadius: "4px",
              overflow: "hidden",
              //minWidth: "500px",
            }}
          >
            {/* Header row */}
            <Box
              sx={{
                borderRight: "1px solid #000000",
                borderBottom: "1px solid #000000",
                p: 1.2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#FFFFFF",
              }}
            >
              <Typography
                sx={{ fontWeight: 700, fontSize: "13px", textAlign: "center" }}
              >
                Status
              </Typography>
            </Box>

            <Box
              sx={{
                borderBottom: "1px solid #000000",
                p: 1.2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#FFFFFF",
              }}
            >
              <Typography
                sx={{ fontWeight: 700, fontSize: "13px", textAlign: "center" }}
              >
                Definition
              </Typography>
            </Box>

            {/* Data rows */}
            {rows.map((row, idx) => (
              <React.Fragment key={row.status}>
                {/* Status cell */}
                <Box
                  sx={{
                    borderRight: "1px solid #000000",
                    borderBottom:
                      idx === rows.length - 1
                        ? "1px solid #000000"
                        : "1px solid #000000",
                    p: 1.5,
                    bgcolor: row.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "14px",
                      textAlign: "center",
                      color: "#000000",
                    }}
                  >
                    {row.status}
                  </Typography>
                </Box>

                {/* Definition cell */}
                <Box
                  sx={{
                    borderBottom:
                      idx === rows.length - 1
                        ? "1px solid #000000"
                        : "1px solid #000000",
                    p: 1.5,
                    bgcolor: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography sx={{ fontSize: "13px", color: "#111827", textAlign: "center", }}>
                    {row.definition}
                  </Typography>
                </Box>

              </React.Fragment>
            ))}
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          sx={{ textTransform: "none", fontFamily: "Outfit" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LegendStatusDefDialog;
